import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootGridContentContainer: {
        padding: '10px',
        width: '100%'
    },
    rootTitle: {
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize22px,
        margin: '10px 0',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize18px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootGridTabsContainer: {
        padding: '10px',
    },
    rootWrapperTab: {
        // marginBottom: '10px',
        padding: '10px 20px 10px 20px',
        cursor: 'pointer',
        fontSize: themeCommon.fontSize18px,
        fontFamily: themeCommon.RobotoBold,
        opacity: 0.6,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    rootWrapperTabActive: {
        background: 'linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), #098EAC',
        opacity: 1,
    },
    rootGridTab: {
        height: '80px',
        boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.25)',
        borderRadius: '20px',
        background: '#FFFFFF',
        textAlign: 'center',
    },
    containerImage: {
        width: '80px',
        '& > img': {
            maxWidth: '100%'
        },
    },
    containerContent: {
        width: 'calc(100% - 80px)',
        textAlign: 'center',
    },
    rootAssessmentHolder: {
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)',
        borderRadius: '20px',
        margin: '15px 0 50px !important',
        padding: '20px 20px 50px 20px',
    },
    rootNote: {
        marginTop: '10px',
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize22px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize18px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootGridDescription: {
        margin: '10px 0',
    },
    rootContent: {
        color: '#2F2F2F',
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize22px,
        textTransform: 'capitalize',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize18px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    assessmentBox: {
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)',
        borderRadius: '20px',
        margin: '15px 0 50px !important',
        padding: '20px 20px 50px 20px',
    }
}), {
    name: 'LCHeadContainer',
    index: 1,
})

export default useStyles